import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function CollisionWithPedestrianIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 31 30"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.36133 13.4814L12.1805 13.6725C12.542 13.6906 12.8262 13.9882 12.8278 14.3501L12.8511 19.6632",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.824 13.7046L8.35547 16.9864",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01308 15.8623L5.22949 15.9825L6.25452 14.0559L6.36418 13.8499C6.49169 14.0762 6.688 14.2406 6.98744 14.2577L7.00256 15.2009L7.01308 15.8623Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9438 13.5102L13.4805 13.0403",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76199 14.2117C6.5844 14.1452 6.45594 14.0137 6.36357 13.8498C6.04393 13.2829 6.15513 12.3283 6.15513 12.3283C6.53393 10.3257 7.79045 9.24706 8.34761 8.85731C8.56595 8.70449 8.81564 8.60109 9.07905 8.56087C9.8344 8.44562 10.1099 8.91776 10.2099 9.30234C10.3185 9.72029 10.4779 10.1235 10.6938 10.4974L11.1664 11.3162C11.2317 11.4291 11.3282 11.5209 11.4443 11.5803L13.0671 12.4107C13.1779 12.4675 13.2715 12.5533 13.3365 12.6594C13.4255 12.8046 13.4687 12.9307 13.4793 13.04L13.4794 13.0401C13.4986 13.2376 13.4113 13.3805 13.2945 13.4819C13.0905 13.6591 12.7976 13.6915 12.5551 13.5723L10.3345 12.4808L9.50397 10.8969C8.93121 11.0843 8.6019 12.0069 8.44692 12.5956C8.37093 12.8843 8.34201 13.1833 8.36053 13.4812L8.45224 14.9566C8.47632 15.3429 8.51682 15.7279 8.56524 16.1119C8.61869 16.5357 8.50637 16.8101 8.35559 16.9864C8.14047 17.2382 7.84711 17.2895 7.84711 17.2895L7.11261 17.3352L4.67649 17.4867C4.45192 17.5007 4.22963 17.4293 4.05775 17.2841C3.72622 17.0042 3.74816 16.7165 3.86602 16.4891C4.00585 16.2195 4.28043 16.0463 4.58341 16.0259L5.22889 15.9824L7.01247 15.8622L7.00195 15.2008L6.99124 14.5321",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07545 17.4634C6.50675 19.2345 4.61002 20.2091 2.83894 19.6404C1.0693 19.0722 0.0936355 17.1736 0.661877 15.4039C1.23058 13.6329 3.1273 12.6582 4.89838 13.2269C5.42876 13.3972 5.8877 13.6865 6.25509 14.0561L5.23006 15.9826L4.58459 16.0261C4.2816 16.0465 4.00702 16.2197 3.86719 16.4893C3.74932 16.7167 3.7274 17.0044 4.05893 17.2844C4.2308 17.4295 4.4531 17.501 4.67766 17.4869L7.11379 17.3354C7.10193 17.3781 7.08915 17.4207 7.07545 17.4634Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2335 21.6999C16.5488 20.3846 16.5488 18.2521 15.2335 16.9368C13.9182 15.6215 11.7857 15.6215 10.4704 16.9368C9.15512 18.2521 9.15512 20.3846 10.4704 21.6999C11.7857 23.0152 13.9182 23.0152 15.2335 21.6999Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0468 8.38295C13.6695 7.7602 13.6695 6.75054 13.0468 6.12779C12.4241 5.50505 11.4144 5.50505 10.7916 6.12779C10.1689 6.75054 10.1689 7.7602 10.7916 8.38295C11.4144 9.00569 12.4241 9.00569 13.0468 8.38295Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0985 19.7828C13.0556 19.9164 12.9125 19.9899 12.779 19.947C12.6454 19.9041 12.5719 19.761 12.6148 19.6275C12.6577 19.4939 12.8007 19.4204 12.9343 19.4633C13.0679 19.5062 13.1414 19.6492 13.0985 19.7828Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4599 16.2544L29.5239 13.9235C29.4601 13.7646 29.3361 13.6373 29.179 13.5693L23.9525 11.3077C23.8076 11.2449 23.6884 11.1344 23.6151 10.9945L22.6676 9.18855C22.6013 9.06228 22.4917 8.96385 22.3585 8.91298C22.1716 8.8416 21.9164 8.81014 21.7838 9.08157C21.7119 9.22855 21.709 9.3999 21.7699 9.55172L22.7427 11.9742C22.7606 12.0186 22.7948 12.0544 22.8383 12.0742L24.2388 12.7115C24.3277 12.752 24.3701 12.8543 24.336 12.9459L23.539 15.085C23.5025 15.183 23.3924 15.2317 23.2954 15.1928L20.9301 14.2451C20.7572 14.1758 20.5644 14.1753 20.3912 14.2436L17.5376 15.3687C17.324 15.4529 17.1625 15.6365 17.1146 15.8611C17.0707 16.0671 17.1234 16.2996 17.4961 16.4228C17.6228 16.4648 17.7593 16.4675 17.8884 16.4332L20.3724 15.7738C20.5618 15.7235 20.7626 15.74 20.9412 15.8205L22.4911 16.5191C22.7668 16.6434 22.7586 17.0377 22.4779 17.1504L21.8535 17.4012C21.6364 17.4884 21.4631 17.6587 21.3722 17.8742L20.1468 20.7782C20.0746 20.9495 20.0912 21.1455 20.192 21.3016C20.302 21.472 20.4817 21.6418 20.7473 21.5892C20.8992 21.5591 21.0298 21.463 21.11 21.3306L22.4518 19.1157C22.5429 18.9654 22.6783 18.8471 22.8394 18.7769L25.5579 17.5931C25.7327 17.517 25.8732 17.3788 25.9522 17.2053L27.0639 14.7638C27.2335 14.3913 27.662 14.2128 28.0459 14.3548L28.2824 14.4422C28.4754 14.5136 28.6356 14.653 28.7331 14.8342L29.6821 16.5982C29.7254 16.6788 29.7876 16.748 29.8642 16.7981C30.0188 16.8991 30.2773 17.0048 30.4335 16.7252C30.514 16.5811 30.5214 16.4074 30.4599 16.2544Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3675 10.9636C28.9934 10.3377 28.9934 9.32297 28.3675 8.69709C27.7416 8.07122 26.7269 8.07121 26.101 8.69708C25.4751 9.32295 25.4751 10.3377 26.101 10.9636C26.7269 11.5894 27.7416 11.5894 28.3675 10.9636Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8145 12.9794L17.874 8.70632C17.9344 8.46251 18.1811 8.31386 18.4249 8.37431C18.6687 8.43476 18.8174 8.68142 18.7569 8.92524C18.7494 8.95534 18.738 8.98619 18.7252 9.01318L16.8145 12.9794Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3145 13.0959L19.837 11.2315C20.0401 11.0814 20.3264 11.1244 20.4764 11.3275C20.6265 11.5305 20.5836 11.8168 20.3805 11.9669C20.3446 11.9934 20.3041 12.0145 20.2642 12.0292L17.3145 13.0959Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2995 12.4224L15.2217 9.47666C15.0359 8.89914 15.8494 8.60112 16.0804 9.16247C16.0957 9.20435 16.1046 9.2492 16.1074 9.29156L16.2995 12.4224Z",
    fill: "currentColor"
  }));
}